// Approval / application for the HR list
const getApproval = (
  isQuote,
  { approvalId, applicationId, employeeName, approvalStatus, referenceNumber }
) => ({
  approvalId,
  applicationId,
  approvalType: isQuote ? 'novated-quote' : 'novated-contract',
  approvalNotes: '',
  approvalReason: '',
  approvalStatus,
  updatedBy: '5f53f694-9c0a-4671-9900-ca91af1c8ddb',
  updatedAt: { _seconds: 1644141655, _nanoseconds: 788000000 },
  erpOrg: 'AFL0223',
  erpOrgName: 'Northrop Grumman Integrated Defence Services Pty Ltd',
  employeeName,
  orgId: '5c2b11d7-c2b1-4d26-99f8-fcd12bb075e2',
  orgUserId: '5f53f694-9c0a-4671-9900-ca91af1c8ddb',
  referenceNumber,
  payrollNumber: null,
  costCenter: null,
  createdAt: { _seconds: 1643680235, _nanoseconds: 585000000 },
  createdBy: '5f53f694-9c0a-4671-9900-ca91af1c8ddb'
});

const getQuoteApproval = (props) => getApproval(true, props);
const getContractApproval = (props) => getApproval(false, props);

const approvals = [
  getQuoteApproval({
    referenceNumber: '11111111',
    approvalId: '11111111-7255-44f1-a02b-adcadad272dc',
    applicationId: '11111111-f916-4a44-af17-91dbeb2f9149',
    employeeName: 'George Lucas',
    approvalStatus: 'pending'
  }),
  getQuoteApproval({
    referenceNumber: '22222222',
    approvalId: '22222222-7255-44f1-a02b-adcadad272dc',
    applicationId: '22222222-f916-4a44-af17-91dbeb2f9149',
    employeeName: 'George Lucas approved',
    approvalStatus: 'approved'
  }),
  getQuoteApproval({
    referenceNumber: '33333333',
    approvalId: '33333333-7255-44f1-a02b-adcadad272dc',
    applicationId: '33333333-f916-4a44-af17-91dbeb2f9149',
    employeeName: 'George Lucas denied',
    approvalStatus: 'denied'
  }),
  getContractApproval({
    referenceNumber: '44444444',
    approvalId: '44444444-0728-41c8-9e30-586626c68972',
    applicationId: '44444444-ef6f-425e-b751-3e21ab6e957f',
    employeeName: 'test test',
    approvalStatus: 'pending'
  }),
  getContractApproval({
    referenceNumber: '55555555',
    approvalId: '55555555-0728-41c8-9e30-586626c68972',
    applicationId: '55555555-ef6f-425e-b751-3e21ab6e957f',
    employeeName: 'test test approved',
    approvalStatus: 'approved'
  }),
  getContractApproval({
    referenceNumber: '66666666',
    approvalId: '66666666-0728-41c8-9e30-586626c68972',
    applicationId: '66666666-ef6f-425e-b751-3e21ab6e957f',
    employeeName: 'test test denied',
    approvalStatus: 'denied'
  })
];

export default {
  data: {
    getApprovals: approvals,
    getApprovalAndApplication: approvals[0],
    hrGrantApplicationApproval: approvals[0],
    createEmployerEmbeddedUrl:
      'https://assets.eclipx.xyz/novatedleasing/documents/FPlus-novated-service-agreement.pdf'
  }
};
